import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttachProductCardFileParams, DeleteFileParams, GetFilesParams} from "../types/product-card-files.types";
import {baseUrl} from "../../../../core/constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class ProductCardFilesApiService {
  private http: HttpClient = inject(HttpClient);

  public fetchFiles<T>({ path, params }: GetFilesParams): Observable<Array<T>> {
    return this.http.get<Array<T>>(`${baseUrl}/${path}`, { params: params });
  }

  public deleteFile({ path, id }: DeleteFileParams): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/${path}/${id}`);
  }

  public attachFile<T>({ path, body }: AttachProductCardFileParams): Observable<T> {
    return this.http.post<T>(`${baseUrl}/${path}`, body);
  }
}
